// extracted by mini-css-extract-plugin
module.exports = {"disabledRow":"AttributeRow_disabledRow_OGQ4-"};